<div *ngIf="twoFactorActivationRequired && !!twofactorCredentials" class="twofa-instruction-container" test-id="two-fa-mandatory">
    <div class="twofa-instruction-description">
        To keep your login extra secure two-factor
        authentication has been enabled on your profile. This
        means you'll need two forms of identification to sign in
        : your login credentials, and a unique passcode
        generated by a two-factor authentication app. To get
        started follow the steps below:
    </div>

    <ol class="twofa-instruction-steps">
        <li class="twofa-instruction-step">
            <div>
                Download a two-factor authenticator app on your
                mobile device.
            </div>
            <div class="twofa-instruction-appstore-image">
                <img src="images/appstore.png" />
            </div>
            <div class="twofa-instruction-app-links">
                <a
                    href="https://itunes.apple.com/au/app/google-authenticator/id388497605?mt=8"
                    >Google Authenticator</a
                >,
                <a
                    href="https://itunes.apple.com/au/app/microsoft-authenticator/id983156458?mt=8"
                    >Microsoft Authenticator</a
                >
            </div>
            <div class="twofa-instruction-googleplay-image">
                <img src="images/googleplay.png" />
            </div>
            <div class="twofa-instruction-app-links">
                <a
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
                    >Google Authenticator</a
                >,
                <a
                    href="https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en"
                    >Microsoft Authenticator</a
                >
            </div>
        </li>
        <li class="twofa-instruction-step">
            Open the app, then scan the QR code below.
        </li>
        <li *ngIf="isMobile" class="twofa-instruction-step">
            Paste the following code into your authenticator app.
        </li>
        <li class="twofa-instruction-step">
            Enter the current six-digit numerical passcode from the
            two-factor authenticator app to complete the setup
            process and press the Verify button.
        </li>
    </ol>
    <div test-id="qrcode-image-container" class="twofa-instruction-qrcode-image-container" *ngIf="!!twofactorCredentials?.qrCodeUrl">
        <img
            [src]="twofactorCredentials?.qrCodeUrl"
            alt="two factor auth qr code image"
            class="twofa-instruction-qrcode-image"
        />
    </div>

    <div *ngIf="isMobile" class="twofa-instruction-mobile-info">
        <p class="twofa-instruction-mobile-shared-key" test-id="mobile-sharedKey">{{ twofactorCredentials?.decryptedSecret }}</p>
        <p>
            Your account: <br /><span test-id="mobile-identity">{{ twofactorCredentials?.identity }}</span>
        </p>
    </div>
</div>
<div *ngIf="!twoFactorActivationRequired" test-id="two-fa-enabled" class="twofa-instruction-enabled-container">
    <div class="twofa-instruction-enabled-message">
        You'll need the six-digit code from your authenticator
        app to continue.
    </div>
</div>